import React, { useState, useEffect } from 'react';
import './VisualAnalytics.css';
import Piechart from './Piechart.js'
import EmissionHeatMap from './EmissionHeatMap.js';
import spline from './SplineChart.js';
import img1 from './icons/BNY.png';
import MetricCard from "./MetricCard";
import SplineChart from './SplineChart.js';
import { Chart } from "chart.js";
import { BiDownload, BiExport } from "react-icons/bi";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const VisualAnalytics = () => {


  const [heatmapData, setHeatmapData] = useState([]);
  const [splineData, setSplineData] = useState([]);

  const emissionsLabelMap = [
    { key: 'CO2', label: 'Carbon Dioxide (CO₂)' },
    { key: 'NOx', label: 'Nitrogen Oxides (NOₓ)' },
    { key: 'PM25', label: 'Particulate Matter (PM)' },
    { key: 'Other', label: 'Other' },
  ];

  const emissionsValueAccessor = (data) => {
    const CO2 = data.totalGrams.CO2;
    const NOx = data.totalGrams.NOx;
    const PM25 = data.totalGrams.PM25;
    const All = data.totalGrams.AllGases;
    const Other = Math.max(0, All - (CO2 + NOx + PM25));

//mock data for now
const mockCO2   = { series: [12, 14, 13, 16, 18, 21, 19, 22, 20, 25] };
const mockNOx   = { series: [3.2, 3.8, 3.5, 3.9, 3.1, 3.4, 3.7, 3.3, 3.6, 3.8] };
const mockPM25  = { series: [1.1, 1.3, 1.2, 1.5, 1.6, 1.4, 1.7, 1.5, 1.4, 1.6] };

    return {
      values: [CO2, NOx, PM25, Other],
      total: All,
    };
  };
// Alternative PNG download for heatmaps
  const downloadPNG = async (selector, filename = "chart.png") => {
    const chartContainer = document.querySelector(selector);
    if (!chartContainer) {
      console.error(`Element with selector "${selector}" not found`);
      return;
    }

    try {
      const webglCanvases = chartContainer.querySelectorAll("canvas");
      const canvasDataUrls = [];

      webglCanvases.forEach((canvas) => {
        try {
          canvasDataUrls.push({
            canvas: canvas,
            dataUrl: canvas.toDataURL("image/png"),
          });
        } catch (e) {
          console.warn("Could not capture canvas:", e);
        }
      });

      const canvas = await html2canvas(chartContainer, {
        backgroundColor: "#1E1E23",
        scale: 3, // Higher resolution for better quality
        useCORS: true,
        allowTaint: true,
        logging: false,
        width: chartContainer.scrollWidth,
        height: chartContainer.scrollHeight,
        // Ensure all content is captured including legends
        onclone: (clonedDoc, element) => {
          const allElements = clonedDoc.querySelectorAll("*");
          allElements.forEach((el) => {
            el.style.visibility = "visible";
            el.style.display =
              el.style.display === "none" ? "block" : el.style.display;
          });

          const clonedCanvases = element.querySelectorAll("canvas");
          clonedCanvases.forEach((clonedCanvas, index) => {
            if (canvasDataUrls[index]) {
              const img = new Image();
              img.src = canvasDataUrls[index].dataUrl;
              img.style.width =
                clonedCanvas.style.width || clonedCanvas.width + "px";
              img.style.height =
                clonedCanvas.style.height || clonedCanvas.height + "px";
              img.style.position = clonedCanvas.style.position;
              img.style.top = clonedCanvas.style.top;
              img.style.left = clonedCanvas.style.left;
              clonedCanvas.parentNode.replaceChild(img, clonedCanvas);
            }
          });
        },
      });

      const url = canvas.toDataURL("image/png", 1.0); // Maximum quality
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
    } catch (error) {
      console.error("Error creating PNG:", error);
    }
  };

  const downloadPDF = async (selector, filename = "chart.pdf") => {
    const chartContainer = document.querySelector(selector);
    if (!chartContainer) {
      console.error(`Element with selector "${selector}" not found`);
      return;
    }

    try {
      const webglCanvases = chartContainer.querySelectorAll("canvas");
      const canvasDataUrls = [];

      webglCanvases.forEach((canvas) => {
        try {
          canvasDataUrls.push({
            canvas: canvas,
            dataUrl: canvas.toDataURL("image/png"),
          });
        } catch (e) {
          console.warn("Could not capture canvas:", e);
        }
      });

      const canvas = await html2canvas(chartContainer, {
        backgroundColor: "#1E1E23",
        scale: 1.5,
        useCORS: true,
        allowTaint: true,
        onclone: (clonedDoc, element) => {
          const clonedContainer = clonedDoc.querySelector(selector);
          if (clonedContainer) {
            clonedContainer.style.visibility = "visible";
            clonedContainer.style.opacity = "1";
          }
          const downloadButtons = clonedDoc.querySelectorAll(".download-btn");
          downloadButtons.forEach((button) => {
            button.style.display = "none";
          });

          const clonedCanvases = element.querySelectorAll("canvas");
          clonedCanvases.forEach((clonedCanvas, index) => {
            if (canvasDataUrls[index]) {
              const img = new Image();
              img.src = canvasDataUrls[index].dataUrl;
              img.style.width =
                clonedCanvas.style.width || clonedCanvas.width + "px";
              img.style.height =
                clonedCanvas.style.height || clonedCanvas.height + "px";
              img.style.position = clonedCanvas.style.position;
              img.style.top = clonedCanvas.style.top;
              img.style.left = clonedCanvas.style.left;
              clonedCanvas.parentNode.replaceChild(img, clonedCanvas);
            }
          });
        },
      });

      const imgData = canvas.toDataURL("image/png");

      // Determine if we should use landscape or portrait based on content ratio
      const aspectRatio = canvas.width / canvas.height;
      const isLandscape = aspectRatio > 1.2;

      // Create PDF with appropriate orientation
      const pdf = new jsPDF({
        orientation: isLandscape ? "landscape" : "portrait",
        unit: "mm",
        format: "a4",
      });

      // Small margins for better appearance
      const margin = 5; // 5mm margins
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = pageWidth - 2 * margin;
      const contentHeight = pageHeight - 2 * margin;

      // Set black background to match app theme
      pdf.setFillColor(30, 30, 35); // #1E1E23 in RGB
      pdf.rect(0, 0, pageWidth, pageHeight, "F");

      let imgWidth, imgHeight;

      if (aspectRatio > contentWidth / contentHeight) {
        imgWidth = contentWidth;
        imgHeight = contentWidth / aspectRatio;
      } else {
        imgHeight = contentHeight;
        imgWidth = contentHeight * aspectRatio;
      }

      const xOffset = margin + (contentWidth - imgWidth) / 2;
      const yOffset = margin + (contentHeight - imgHeight) / 2;

      pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);

      pdf.save(filename);
    } catch (error) {
      console.error("Error creating PDF:", error);
    }
  };

  const downloadFullPagePDF = async () => {
    const fullPageContainer = document.querySelector(".visual-page");
    if (!fullPageContainer) {
      console.error("Visual page container not found");
      return;
    }

    try {
      const webglCanvases = fullPageContainer.querySelectorAll("canvas");
      const canvasDataUrls = [];

      webglCanvases.forEach((canvas) => {
        try {
          canvasDataUrls.push({
            canvas: canvas,
            dataUrl: canvas.toDataURL("image/png"),
          });
        } catch (e) {
          console.warn("Could not capture canvas:", e);
        }
      });

      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a3",
      });

      // Small margins for better appearance
      const margin = 5; // 5mm margins
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = pageWidth - 2 * margin;
      const contentHeight = pageHeight - 2 * margin;

      // Calculate target canvas dimensions in pixels (96 DPI)
      const targetCanvasWidth = (contentWidth * 96) / 25.4; // mm to pixels
      const targetCanvasHeight = (contentHeight * 96) / 25.4; // mm to pixels

      const containerWidth = fullPageContainer.scrollWidth;
      const containerHeight = fullPageContainer.scrollHeight;
      const scaleX = targetCanvasWidth / containerWidth;
      const scaleY = targetCanvasHeight / containerHeight;
      const optimalScale = Math.min(scaleX, scaleY, 2);
      const canvas = await html2canvas(fullPageContainer, {
        backgroundColor: "#1E1E23",
        scale: optimalScale,
        useCORS: true,
        allowTaint: true,
        height: fullPageContainer.scrollHeight,
        width: fullPageContainer.scrollWidth,
        onclone: (clonedDoc, element) => {
          const clonedContainer = clonedDoc.querySelector(".visual-page");
          if (clonedContainer) {
            clonedContainer.style.visibility = "visible";
            clonedContainer.style.opacity = "1";
          }

          const downloadButtons = clonedDoc.querySelectorAll(".download-btn");
          downloadButtons.forEach((button) => {
            button.style.display = "none";
          });

          const clonedCanvases = element.querySelectorAll("canvas");
          clonedCanvases.forEach((clonedCanvas, index) => {
            if (canvasDataUrls[index]) {
              const img = new Image();
              img.src = canvasDataUrls[index].dataUrl;
              img.style.width =
                clonedCanvas.style.width || clonedCanvas.width + "px";
              img.style.height =
                clonedCanvas.style.height || clonedCanvas.height + "px";
              img.style.position = clonedCanvas.style.position;
              img.style.top = clonedCanvas.style.top;
              img.style.left = clonedCanvas.style.left;
              clonedCanvas.parentNode.replaceChild(img, clonedCanvas);
            }
          });
        },
      });

      const imgData = canvas.toDataURL("image/png");

      // Set black background to match app theme
      pdf.setFillColor(30, 30, 35); // #1E1E23 in RGB
      pdf.rect(0, 0, pageWidth, pageHeight, "F");

      const aspectRatio = canvas.width / canvas.height;
      let imgWidth, imgHeight;

      if (aspectRatio > contentWidth / contentHeight) {
        imgWidth = contentWidth;
        imgHeight = contentWidth / aspectRatio;
      } else {
        imgHeight = contentHeight;
        imgWidth = contentHeight * aspectRatio;
      }

      const xOffset = margin + (contentWidth - imgWidth) / 2;
      const yOffset = margin + (contentHeight - imgHeight) / 2;

      pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);

      pdf.save("mobility-analysis-full-report.pdf");
    } catch (error) {
      console.error("Error creating full page PDF:", error);
    }
  };
  useEffect(() => {
    const fetchHeatmapData = async () => {
      try {
        const res = await fetch('/api/link/links/emissions?format=heatmap'); //currently getting data for all links
        const data = await res.json();
        setHeatmapData(data);
      } catch (err) {
        console.error('Error fetching heatmap data:', err);
      }
    };

    fetchHeatmapData();

  }, []);

  useEffect(() => {
    const fetchSplineData = async () => {
      try {
        const res = await fetch("/api/link/links/mockemissionsfull");
        const data = await res.json();
        setSplineData(data);
      } catch (err) {
        console.error("Error fetching spline data:", err);
      }
    };
    fetchSplineData();
  }, []);



  return (
    <div className="visual-page">
      <button
        className="download-btn"
        onClick={downloadFullPagePDF}
        style={{
          fontSize: "14px",
          padding: "8px 12px",
          marginTop: "0px",
        }}
      >
        <BiExport style={{ color: "#84cc16", fontSize: "16px" }} />
        Export All
      </button>
      <div className="project-overview">
        <div className="project-info">
          <header className="visual-header">
            <h2>Brooklyn Project Visual Analytics</h2>
            <p className="subtext">Date Created: January 1, 2025 | Last Modified: 2 weeks ago</p>
            <div className="tag-container">
              <span className="tag">Tag 1</span>
              <span className="tag">Tag 2</span>
            </div>
          </header>
          <div className="sum-dets">
            <div className="details-section">
              <h3>DETAILS</h3>
              <p><strong>Region:</strong> Brooklyn, New York</p>
              <p><strong>Evaluation Duration:</strong> 01/01/2025 – 01/07/2025</p>
              <p><strong>Project Cost:</strong> $XXX</p>
            </div>

            <div className="summary-section">
              <h3>SUMMARY</h3>
              <p>
                Sample description that includes details that were required in first step of the CAT Analyzer Scenario.
                Sample description that includes details that were required in first step of the CAT Analyzer Scenario.
                Sample description that includes details that were required.
              </p>
            </div>
          </div>
        </div>

        <div className="project-map">
          <img src={img1} alt="Brooklyn Map" />
        </div>
      </div>

      <div class="emission-column">
        <h3>Emissions Analysis</h3>
        <div class="emission-row">
          <div class="emission-breakdown">
            <h2> Emissions Breakdown </h2>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    className="download-btn"
                    onClick={() =>
                      downloadPDF(
                        ".emissions-pie-chart",
                        "emissions-pie-chart.pdf"
                      )
                    }
                  >
                    <BiDownload
                      style={{ color: "#84cc16", fontSize: "14px" }}
                    />
                    PDF
                  </button>
                  <button
                    className="download-btn"
                    onClick={() =>
                      downloadPNG(
                        ".emissions-pie-chart",
                        "emissions-pie-chart.png"
                      )
                    }
                  >
                    <BiDownload
                      style={{ color: "#84cc16", fontSize: "14px" }}
                    />
                    PNG
                  </button>
                </div>
            <Piechart
              endpoint="/api/link/links/emissions/summary"
              labelMap={emissionsLabelMap}
              valueAccessor={emissionsValueAccessor}
              title="total metric tons"
            />
          </div>
          <div class="emission-breakdown-heatmap-row">
            <h2>Vehicle Emissions Distribution Breakdown</h2>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    className="download-btn"
                    onClick={() =>
                      downloadPDF(
                        ".emissions-heatmap",
                        ".emissions-heatmap.pdf"
                      )
                    }
                  >
                    <BiDownload
                      style={{ color: "#84cc16", fontSize: "14px" }}
                    />
                    PDF
                  </button>
                  <button
                    className="download-btn"
                    onClick={() =>
                      downloadPNG(
                        ".emissions-heatmap",
                        "emissions-heatmap.png"
                      )
                    }
                  >
                    <BiDownload
                      style={{ color: "#84cc16", fontSize: "14px" }}
                    />
                    PNG
                  </button>
                </div>    
            <div className="legend-container">
              <div className="legend-items">
                <button className="tag">Carbon Dioxide (CO₂)</button>
                <button className="tag"> Nitrogen Oxides (NOₓ)</button>
                <button className="tag">Particulate Matter (PM)</button>
                <button className="tag">Other Emission Types</button>
              </div>
            </div>
            <EmissionHeatMap data={heatmapData} />
          </div>
        </div>
      </div>

      <div className="accidents-emission-column">
        <div className="emission-row">
          <div className="emission-breakdown-heatmap-row">
            <h2>Average Speed and Emissions Report</h2>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    className="download-btn"
                    onClick={() =>
                      downloadPDF(
                        ".accidents-heatmap",
                        "accidents-heatmap.pdf"
                      )
                    }
                  >
                    <BiDownload
                      style={{ color: "#84cc16", fontSize: "14px" }}
                    />
                    PDF
                  </button>
                  <button
                    className="download-btn"
                    onClick={() =>
                      downloadPNG(
                        ".accidents-heatmap",
                        "accidents-heatmap.png"
                      )
                    }
                  >
                    <BiDownload
                      style={{ color: "#84cc16", fontSize: "14px" }}
                    />
                    PNG
                  </button>
                </div>
            <SplineChart data={splineData} />
          </div>
        </div>
      </div>

      <div class="vehicle-flow-emission-column">
        <h3>Vehicle Flow & Emissions Analysis</h3>
        <div class="emission-row">
          <div class="emission-breakdown">
            <h2> Emissions Breakdown </h2>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  className="download-btn"
                  onClick={() =>
                    downloadPDF(
                      ".vehicle-flow-pie-chart",
                      ".vehicle-flow-pie-chart.pdf"
                    )
                  }
                >
                  <BiDownload
                    style={{ color: "#84cc16", fontSize: "14px" }}
                  />
                  PDF
                </button>
                <button
                  className="download-btn"
                  onClick={() =>
                    downloadPNG(
                      ".vehicle-flow-pie-chart",
                      "vehicle-flow-pie-chart.png"
                    )
                  }
                >
                  <BiDownload
                    style={{ color: "#84cc16", fontSize: "14px" }}
                  />
                  PNG
                </button>
              </div>
          <Piechart
            endpoint="/api/link/links/emissions/summary"
            labelMap={emissionsLabelMap}
            valueAccessor={emissionsValueAccessor}
            title="total metric tons"
          />
        </div>
          <div class="emission-breakdown-heatmap-row">
            <h2>Vehicle Emissions Distribution Breakdown</h2>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  className="download-btn"
                  onClick={() =>
                    downloadPDF(
                      ".vehicle-flow-heatmap",
                      ".vehicle-flow-heatmap.pdf"
                    )
                  }
                >
                  <BiDownload
                    style={{ color: "#84cc16", fontSize: "14px" }}
                  />
                  PDF
                </button>
                <button
                  className="download-btn"
                  onClick={() =>
                    downloadPNG(
                      ".vehicle-flow-heatmap",
                      "vehicle-flow-heatmap.png"
                    )
                  }
                >
                  <BiDownload
                    style={{ color: "#84cc16", fontSize: "14px" }}
                  />
                  PNG
                </button>
              </div>
            <div className="legend-container">
              <div className="legend-items">
                <button className="tag">Carbon Dioxide (CO₂)</button>
                <button className="tag"> Nitrogen Oxides (NOₓ)</button>
                <button className="tag">Particulate Matter (PM)</button>
                <button className="tag">Other Emission Types</button>
              </div>
            </div>
            <EmissionHeatMap data={heatmapData} />
          </div>
        </div>
      </div>

    </div>
  );
};

export default VisualAnalytics;
